// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Date-module--cls1--2yrhw","cls2":"styles-Date-module--cls2--26bNt styles-Date-module--cls1--2yrhw"};